<template>
  <div>
    <a-upload
      name="file"
      list-type="picture-card"
      class="avatar-uploader"
      :show-upload-list="false"
      :customRequest="handleHttpRequest"
      :before-upload="beforeAvatarUpload">
      <img
        ref="img"
        v-if="currentImgPath && type==='IMAGE'"
        :src="currentImgPath"
        alt="avatar"
        style="width: 100%"/>
      <video
        ref="video"
        v-if="currentImgPath && type==='VIDEO'"
        :src="currentImgPath"
        style="width: 100%"/>
      <div
        v-if="!currentImgPath">
        <a-icon :type="loading ? 'loading' : 'plus'"/>
        <div class="ant-upload-text">Upload</div>
      </div>
      <div
        v-else
        @click="removeFile"
        class="remove-btn-wrap">
        <a-button type="danger" size="small" shape="round">clear</a-button>
      </div>
    </a-upload>
    <a-modal
      :footer="null"
      title="联名编辑"
      v-model="review">
      <img
        v-if="type==='IMAGE'"
        :src="currentImgPath"
        alt=""/>
      <video
        v-if="type==='VIDEO'"
        :src="currentImgPath"
        style="width: 100%;height: auto"/>
      <audio
        v-if="type==='AUDIO'"
        :src="currentImgPath"
        style="width: 100%;height: auto"/>
    </a-modal>
  </div>
</template>

<script>
import S3Client from '@/utils/S3Client';

export default {
  name: 'SimpleUploaderS3',
  props: {
    value: String,
    type: {
      type: String,
      default: 'IMAGE',
    },
  },
  watch: {
    value(val) {
      this.currentImgPath = val;
    },
  },
  data() {
    return {
      loading: false,
      review: false,
      imageUrl: '',
      currentImgPath: this.value,
    };
  },
  methods: {
    getSize() {
      if (this.type === 'IMAGE') {
        return {
          width: this.$refs.img.naturalWidth,
          height: this.$refs.img.naturalHeight,
        };
      }
      return {
        width: this.$refs.video.videoWidth,
        height: this.$refs.video.videoHeight,
      };
    },

    random_string(len) {
      const length = len || 32;
      const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678';
      const maxPos = chars.length;
      let pwd = '';
      for (let i = 0; i < length; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    async handleHttpRequest(option) {
      // 上传OSS
      const client = S3Client();
      // 随机命名
      const randomName = `${this.random_string(6)}_${new Date().getTime()}.${option.file.name.split('.').pop()}`;
      console.log(randomName)
      try {
        // 分片上传文件
        // const result = await client.upload(randomName, option.file);
        const result = await client.upload({
          Bucket: 'lama-hourani',
          Key: randomName,
          Body: option.file,
          ContentType: option.file.type,
          ACL: 'public-read',
          'Access-Control-Allow-Origin': '*',
        }, (err, data) => {
          if (err) {
            console.log(err);
            // 上传失败
          } else if (data) {
            this.currentImgPath = 'https://lama-hourani.s3.us-east-2.amazonaws.com/' + randomName;
            console.log(this.currentImgPath)
            this.$emit('input', this.currentImgPath);
          }
        })
      } catch (error) {
        console.log(error)
        this.$message.error('上传失败');
      }
    },

    removeFile(e) {
      e.preventDefault();
      e.stopPropagation();
      this.currentImgPath = null;
      this.$emit('input', null);
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    handleAvatarSuccess(res) {
      this.currentImgPath = res;
      this.$emit('input', res);
    },
    beforeAvatarUpload(file) {
      return true;
    },
  },
};
</script>

<style>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 0;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader {
  border-color: #409EFF;
}

.avatar-uploader {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

</style>
